module.exports = __webpack_public_path__ + "img/13.a3215068.png";